import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import Card from '@shell/components/Resource/Detail/Card/index.vue';
import { ref, watch } from 'vue';
import {
  DEFAULT_FOCUS_TRAP_OPTS,
  useWatcherBasedSetupFocusTrapWithDestroyIncluded
} from '@shell/composables/focusTrap';
import RcButton from '@components/RcButton/RcButton.vue';

export interface Props {
  cardTitle: string;
  fallbackFocus?: string;
  showPopoverAriaLabel?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PopoverCard',
  props: {
    cardTitle: {},
    fallbackFocus: { default: 'body' },
    showPopoverAriaLabel: { default: 'Show more' }
  },
  setup(__props: any) {

const props = __props;
const card = ref<any>(null);
const popoverContainer = ref(null);
const showPopover = ref<boolean>(false);
const focusOpen = ref<boolean>(false);

// Set focus trap when card opened using keyboard
watch(
  () => card.value,
  (neu) => {
    if (neu && focusOpen.value) {
      const opts = {
        ...DEFAULT_FOCUS_TRAP_OPTS,
        fallbackFocus:  props.fallbackFocus,
        setReturnFocus: () => '.focus-button'
      };

      useWatcherBasedSetupFocusTrapWithDestroyIncluded(() => showPopover.value, '#popover-card', opts);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_dropdown = _resolveComponent("v-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popover-card-base", {open: showPopover.value}]),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => {showPopover.value=false; focusOpen.value=false}),
    onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => {showPopover.value=false; focusOpen.value=false}, ["escape"]))
  }, [
    _createVNode(_component_v_dropdown, {
      triggers: [],
      container: popoverContainer.value,
      shown: showPopover.value,
      placement: "bottom-start"
    }, {
      popper: _withCtx(() => [
        _renderSlot(_ctx.$slots, "card", {}, () => [
          _createVNode(Card, {
            id: "popover-card",
            ref_key: "card",
            ref: card,
            class: "popover-card",
            title: props.cardTitle
          }, {
            "heading-action": _withCtx(() => [
              _renderSlot(_ctx.$slots, "heading-action", {
                close: () => {showPopover.value=false; focusOpen.value=false;}
              })
            ]),
            default: _withCtx(() => [
              _cache[7] || (_cache[7] = _createTextVNode()),
              _renderSlot(_ctx.$slots, "card-body")
            ]),
            _: 3
          }, 8, ["title"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "popover-card-target",
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (showPopover.value=true))
        }, [
          _renderSlot(_ctx.$slots, "default"),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createVNode(RcButton, {
            variant: "ghost",
            class: "focus-button",
            "aria-label": props.showPopoverAriaLabel,
            "aria-haspopup": "true",
            "aria-expanded": showPopover.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => {showPopover.value=true; focusOpen.value=true;})
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "icon icon-chevron-down icon-sm" }, null, -1)
            ]))]),
            _: 1
          }, 8, ["aria-label", "aria-expanded"]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createElementVNode("div", {
            ref_key: "popoverContainer",
            ref: popoverContainer,
            class: "popover-card-container"
          }, null, 512)
        ], 32),
        _cache[8] || (_cache[8] = _createTextVNode())
      ]),
      _: 3
    }, 8, ["container", "shown"])
  ], 34))
}
}

})